import { IOrgSettings } from "@/hooks/useOrg";
import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { create } from "zustand";

interface IPointTiers {
  bronze?: number;
  gold?: number;
  platinum?: number;
  silver?: number;
}
interface IOrgSettingsStore {
  general: {
    disclaimer: IOrgSettings["disclaimer"] | null;
    privacyPolicy: IOrgSettings["privacyPolicy"] | null;
    termsConditions: IOrgSettings["termsConditions"] | null;
    waivers: IOrgSettings["waivers"] | null;
  };
  events: {
    allowAllCreateEvent: IOrgSettings["allowAllCreateEvent"] | null;
  };
  circles: {
    allowAllCreateCircle: IOrgSettings["allowAllCreateCircle"] | null;
  };
  connections: {
    maxNoOfMinIntroducers: IOrgSettings["maxNoOfMinIntroducers"] | null;
  };
  onboarding:
    | {
        key: string;
        value: string;
      }[]
    | null;
  setGeneral: (payload: any) => void;
  setEvent: (payload: any) => void;
  setCircle: (payload: any) => void;
  setConnection: (payload: any) => void;
  setOnboarding: (payload: any) => void;
  _version: number;
  id: string;
  setVersion: (payload: number, id: string) => void;
  pointTiers: IPointTiers;
  setPointTiers: (payload: IPointTiers) => void;
}

export const OrgSettings = create<IOrgSettingsStore>((set) => ({
  general: {
    disclaimer: null,
    privacyPolicy: null,
    termsConditions: null,
    waivers: null,
  },
  events: {
    allowAllCreateEvent: null,
  },
  circles: {
    allowAllCreateCircle: null,
  },
  connections: {
    maxNoOfMinIntroducers: null,
  },
  onboarding: null,
  pointTiers: {},
  setGeneral: (payload: any) => {
    set(() => ({ general: payload }));
  },
  setEvent: (payload: any) => {
    set(() => ({ events: payload }));
  },
  setCircle: (payload: any) => {
    set(() => ({ circles: payload }));
  },
  setConnection: (payload: any) => {
    set(() => ({ connections: payload }));
  },
  setOnboarding: (payload: any) => {
    set(() => ({ onboarding: payload }));
  },
  setPointTiers: (payload: any) => {
    set(() => ({ pointTiers: payload }));
  },
  _version: 0,
  id: "",
  setVersion: (_version: number, id: string) => set(() => ({ _version, id })),
}));

const useOrgSettingStore = createSelectorHooks(OrgSettings);

export default useOrgSettingStore;
